module.exports = __webpack_public_path__ + "img/go-code.18756d50.png";